import { GetPlacesResponse } from '@/features/places/types/places.type';
import { ActionType } from '@/types/actionType';
import { GeofenceAction } from './geofenceAction';

type State = {
	geofences: Record<number, GetPlacesResponse>;
	selectedGeofenceId: number | null;
};

const INITIAL_STATE: State = {
	geofences: {},
	selectedGeofenceId: null,
};

const geofenceReducer = (state: State = INITIAL_STATE, action: GeofenceAction): State => {
	switch (action.type) {
		case ActionType.GEOFENCE_SET_GEOFENCES: {
			const geofencesHash: Record<number, GetPlacesResponse> = {};
			action.payload.forEach((geofence) => {
				geofencesHash[geofence.id] = geofence;
			});
			return {
				...state,
				geofences: geofencesHash,
			};
		}

		case ActionType.GEOFENCE_UPDATE_GEOFENCE: {
			const geofence = action.payload;
			if (!state.geofences[geofence.id]) {
				return state;
			}
			return {
				...state,
				geofences: {
					...state.geofences,
					[geofence.id]: geofence,
				},
			};
		}

		case ActionType.GEOFENCE_UPDATE_BEHAVIOR: {
			const updatedBehavior = action.payload;
			const geofenceId = updatedBehavior.placeId;
			const geofence = state.geofences[geofenceId];

			if (!geofence) {
				return state;
			}

			const updatedBehaviors = geofence.behaviors.map((currentBehavior) =>
				currentBehavior.id === updatedBehavior.id ? updatedBehavior : currentBehavior
			);

			return {
				...state,
				geofences: {
					...state.geofences,
					[geofenceId]: {
						...geofence,
						behaviors: updatedBehaviors,
					},
				},
			};
		}

		case ActionType.GEOFENCE_ADD_BEHAVIOR: {
			const newBehavior = action.payload;
			const geofenceId = newBehavior.placeId;
			const geofence = state.geofences[geofenceId];

			if (!geofence) {
				return state;
			}

			const updatedBehaviors = [...geofence.behaviors, newBehavior];

			return {
				...state,
				geofences: {
					...state.geofences,
					[geofenceId]: {
						...geofence,
						behaviors: updatedBehaviors,
					},
				},
			};
		}

		case ActionType.GEOFENCE_PANEL_DELETE_GEOFENCES: {
			const newGeofences = { ...state.geofences };
			action.payload.forEach((id) => {
				delete newGeofences[id];
			});
			return {
				...state,
				geofences: newGeofences,
			};
		}

		case ActionType.GEOFENCE_PANEL_DELETE_GEOFENCE_BEHAVIORS: {
			const { geofenceId, behaviorIds } = action.payload;
			const geofence = state.geofences[geofenceId];

			if (!geofence) {
				return state;
			}

			const updatedBehaviors = geofence.behaviors?.filter((behavior) => !behaviorIds.includes(behavior.id)) ?? [];

			return {
				...state,
				geofences: {
					...state.geofences,
					[geofenceId]: {
						...geofence,
						behaviors: updatedBehaviors,
					},
				},
			};
		}

		case ActionType.GEOFENCE_SET_SELECTED_ID: {
			return {
				...state,
				selectedGeofenceId: action.payload,
			};
		}

		case ActionType.GEOFENCE_CLEAR_SELECTED_ID: {
			return {
				...state,
				selectedGeofenceId: null,
			};
		}
		default:
			return state;
	}
};

export default geofenceReducer;
